export const ROUTE_NAME = {
  MANAGER: 'manager',
  PRINT: 'print',
  DIGITAL: 'digital',
  PRINT_EDIT: 'editPrint',
  DIGITAL_EDIT: 'editDigital',
  PRINT_PAGE: 'printPage',
  PLAYBACK_PREVIEW_PAGE: 'playbackPreview'
};
